<ion-content>
  <div class="adjust-container">
    <div class="select-container">
      <div class="select-row">
        <ion-icon name="ios-paper-outline"></ion-icon>
        <ion-select [(ngModel)]="activeEventName" (ionChange)="onEventNameChange()" class="border-bottom">
          <ion-option *ngFor="let event of eventList" [value]="event.value">{{ event.value }}</ion-option>
        </ion-select>
      </div>
      <div class="select-row">
        <ion-icon large name="ios-calendar-outline"></ion-icon>
        <ion-select [(ngModel)]="activeDate">
          <ion-option *ngFor="let date of eventDates" [value]="date.value">{{ date.value }}</ion-option>
        </ion-select>
      </div>
    </div>
    <hr />
    <div class="button-switch-container">
      <button ion-button (click)="onTeamPressed()">{{ 'TEAM_RESULTS' | translate }}</button>
      <button ion-button (click)="onTotalPressed()">{{ 'TOTAL_RESULTS' | translate }}</button>
    </div>
  </div>

  <result-ranglist-list-item *ngFor="let result of resultList" [result]="result" [distance]="showDistance">
  </result-ranglist-list-item>
  <ion-infinite-scroll (ionInfinite)="loadNextPage($event)"
    *ngIf="resultList.length % 25 === 0 && resultList.length > 0">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>